const confirmPaymentTarget = document.getElementById("confirm-payment");

export const hideConfirmPayment = () => {
  if (confirmPaymentTarget) {
    confirmPaymentTarget.style.display = "none";
  }
};

export const showConfirmPayment = () => {
  if (confirmPaymentTarget) {
    confirmPaymentTarget.hasAttribute("style") && confirmPaymentTarget.removeAttribute("style");
  }
};
